import BaseVm from './BaseVm'
import { makeSafeFn } from '../../utils/fn'
import { selectText } from '../../utils/dom'

export default class EmbedCodeModalVm extends BaseVm {
  selectEmbedCode(embedCodeElement) {
    embedCodeElement.focus()
    makeSafeFn(() => selectText(embedCodeElement)).call()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/embedCodeModalVm.js